import React, { useMemo } from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { TopRoutes } from "../../../components/Utils/routes";
import { GENERAL_ROUTES } from "../../routes";

const NavToHome = () => {
  const search = useMemo(() => {
    return window.location.search;
  }, []);

  return (
    <Navigate
      to={{
        pathname: TopRoutes().home.path,
        search,
      }}
    />
  );
};

export const GeneralRoutes: RouteObject[] = [
  {
    path: GENERAL_ROUTES.ConfigHandler,
    lazy: async () => {
      const { ConfigHandler } = await import(
        "../../../domains/Settings/ConfigHandler"
      );
      return { element: <ConfigHandler /> };
    },
  },
  {
    path: GENERAL_ROUTES.Home,
    lazy: async () => {
      const { HomeDashboard } = await import("../../../domains/HomeDashboard");
      return { element: <HomeDashboard /> };
    },
  },
  {
    path: GENERAL_ROUTES.Readme_Login,
    lazy: async () => {
      const { ReadMeLogin } = await import("../../../domains/ReadMe/login");
      return { element: <ReadMeLogin /> };
    },
  },
  {
    path: GENERAL_ROUTES.Logout,
    lazy: async () => {
      const { LogoutRedirect } = await import(
        "../../../domains/Redirects/LogoutRedirect"
      );
      return { element: <LogoutRedirect /> };
    },
  },
  {
    path: GENERAL_ROUTES.PriceScraper,
    lazy: async () => {
      const { PriceScraper } = await import("../../../domains/PriceScraper");
      return { element: <PriceScraper /> };
    },
  },
  // {
  //   path: GENERAL_ROUTES.IntelligemsAi,
  //   lazy: async () => {
  //     const { IntelligemsAi } = await import("../../../domains/IntelligemsAi");
  //     return { element: <IntelligemsAi /> };
  //   },
  // },
  {
    path: GENERAL_ROUTES.Performance,
    lazy: async () => {
      const { PerformanceRoute } = await import(
        "../../../domains/Performance/PerformanceRoute"
      );
      return { element: <PerformanceRoute /> };
    },
  },
  {
    path: GENERAL_ROUTES.Integrations,
    lazy: async () => {
      const { IntegrationsRoute } = await import(
        "../../../domains/Settings/Integrations"
      );
      return { element: <IntegrationsRoute /> };
    },
  },
  {
    path: GENERAL_ROUTES.GoogleIntegrationCallback,
    lazy: async () => {
      const { GoogleCallbackRoute } = await import(
        "../../../domains/Settings/Integrations/Google/GoogleCallback"
      );
      return { element: <GoogleCallbackRoute /> };
    },
  },
  {
    path: GENERAL_ROUTES.Index,
    element: <NavToHome />,
  },
  {
    path: GENERAL_ROUTES.ConfigCompare,
    lazy: async () => {
      const { ConfigCompareDomain } = await import(
        "../../../domains/ConfigCompare"
      );
      return { element: <ConfigCompareDomain /> };
    },
  },
];
